import React, {useState, useEffect} from 'react'
import {useField} from "formik";


export const changeOnBlur = (name, value, onChange, onBlur, setOn = 'blur') => {
    const [field,ignore,helpers] = useField(name)
    const [val, setValue] = useState(value)
    useEffect(() => {
        setValue(value)
    },[value])
    const onChangeAfter = (e) => {
        console.log('OnChange After', e.target.value, e, val, value)
        if(setOn === 'change')helpers.setValue(e.target.value,true)
        else setValue(e.target.value)
    }
    const onBlurAfter = (e) => {
        console.log('OnBlur After', e.target.value, e, val, value)
        if(setOn.includes('blur'))helpers.setValue(setOn === 'blur:val' ? e.target.value : val,true)
        onBlur(e)
    }
    return {value: val, onBlur: onBlurAfter, onChange: onChangeAfter}
}